import React from 'react';

export default function ProposalSection() {
  return (
    <section id="proposal" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0d0a14 0%, #120a1f 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Rose petals BG */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
        {['🌹','🌸','💐','🌷','✨'].map((e, i) => (
          <div key={i} style={{
            position: 'absolute',
            fontSize: '20px',
            opacity: 0.15,
            top: `${10 + i * 18}%`,
            left: `${5 + i * 8}%`,
            animation: `float ${4 + i}s ease-in-out infinite`,
            animationDelay: `${i * 0.5}s`,
          }}>{e}</div>
        ))}
        {['💕','🌹','✨','🌸'].map((e, i) => (
          <div key={i} style={{
            position: 'absolute',
            fontSize: '18px',
            opacity: 0.12,
            top: `${15 + i * 20}%`,
            right: `${5 + i * 8}%`,
            animation: `float ${3.5 + i}s ease-in-out infinite`,
            animationDelay: `${i * 0.8}s`,
          }}>{e}</div>
        ))}
      </div>

      <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <div className="section-badge" style={{ margin: '0 auto 20px', display: 'inline-flex', borderColor: 'rgba(255,107,157,0.4)', background: 'rgba(255,107,157,0.1)' }}>
          <span>💍</span> Chapter 5
        </div>
        <h2 style={{
          fontFamily: 'Poppins, sans-serif', fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 58px)', lineHeight: 1.15, marginBottom: 8,
        }}>
          First Proposal from <span className="gradient-text">Hassan</span>
        </h2>
        <div className="section-divider center" />
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          padding: '8px 18px',
          background: 'rgba(255,107,157,0.08)',
          border: '1px solid rgba(255,107,157,0.2)',
          borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
          color: '#ff6b9d', marginBottom: 48,
        }}>
          💍 27 July 2025
        </div>

        {/* Proposal Illustration */}
        <div style={{ margin: '0 auto 48px', animation: 'float 5s ease-in-out infinite' }}>
          <svg viewBox="0 0 360 280" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 360, margin: '0 auto', display: 'block' }}>
            <defs>
              <linearGradient id="propGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ff6b9d" />
                <stop offset="100%" stopColor="#a855f7" />
              </linearGradient>
              <radialGradient id="propBg" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="rgba(255,107,157,0.08)" />
                <stop offset="100%" stopColor="rgba(0,0,0,0)" />
              </radialGradient>
            </defs>
            <ellipse cx="180" cy="140" rx="160" ry="120" fill="url(#propBg)" />

            {/* Hassan kneeling */}
            <circle cx="120" cy="95" r="22" fill="#2d1f4a" />
            <circle cx="113" cy="91" r="4" fill="#a855f7" />
            <circle cx="127" cy="91" r="4" fill="#a855f7" />
            <circle cx="113" cy="91" r="2" fill="#1a0a2e" />
            <circle cx="127" cy="91" r="2" fill="#1a0a2e" />
            <path d="M114,104 Q120,110 126,104" stroke="#ff9db5" strokeWidth="2.5" fill="none" strokeLinecap="round" />
            {/* Body */}
            <rect x="100" y="117" width="40" height="45" rx="10" fill="#a855f7" />
            {/* Kneeling leg */}
            <path d="M100,155 Q90,165 88,180" stroke="#2d1f4a" strokeWidth="14" strokeLinecap="round" fill="none" />
            <path d="M140,155 Q150,165 148,180" stroke="#2d1f4a" strokeWidth="14" strokeLinecap="round" fill="none" />
            {/* Arm with ring box */}
            <path d="M140,130 Q160,120 165,125" stroke="#a855f7" strokeWidth="12" strokeLinecap="round" fill="none" />

            {/* Ring box */}
            <rect x="158" y="115" width="30" height="22" rx="4" fill="#d4af37" />
            <rect x="158" y="115" width="30" height="10" rx="4" fill="#ffd700" />
            <line x1="173" y1="115" x2="173" y2="137" stroke="rgba(0,0,0,0.2)" strokeWidth="1" />
            {/* Diamond */}
            <polygon points="173,108 178,113 173,118 168,113" fill="#38bdf8" />
            <polygon points="173,108 178,113 173,118 168,113" fill="none" stroke="white" strokeWidth="0.5" />

            {/* Fiza standing, surprised */}
            <circle cx="240" cy="90" r="22" fill="#2d1f4a" />
            {/* Hair */}
            <path d="M221,86 Q219,73 227,69 Q240,63 253,69 Q261,73 259,86" fill="#1a0a2e" />
            <path d="M221,86 Q217,98 221,112" stroke="#1a0a2e" strokeWidth="10" strokeLinecap="round" fill="none" />
            <path d="M259,86 Q263,98 259,112" stroke="#1a0a2e" strokeWidth="10" strokeLinecap="round" fill="none" />
            <circle cx="233" cy="86" r="4" fill="#ff6b9d" />
            <circle cx="247" cy="86" r="4" fill="#ff6b9d" />
            <circle cx="233" cy="86" r="2" fill="#1a0a2e" />
            <circle cx="247" cy="86" r="2" fill="#1a0a2e" />
            <circle cx="233" cy="86" r="1" fill="white" opacity="0.8" />
            <circle cx="247" cy="86" r="1" fill="white" opacity="0.8" />
            <path d="M234,101 Q240,107 246,101" stroke="#ff9db5" strokeWidth="2.5" fill="none" strokeLinecap="round" />
            {/* Blush */}
            <circle cx="228" cy="96" r="5" fill="#ff9db5" opacity="0.3" />
            <circle cx="252" cy="96" r="5" fill="#ff9db5" opacity="0.3" />
            <rect x="220" y="112" width="40" height="50" rx="12" fill="#ff6b9d" />
            {/* Surprised hands on face */}
            <path d="M218,125 Q213,115 218,120" stroke="#2d1f4a" strokeWidth="11" strokeLinecap="round" fill="none" />
            <path d="M262,125 Q267,115 262,120" stroke="#2d1f4a" strokeWidth="11" strokeLinecap="round" fill="none" />

            {/* Hearts floating up */}
            <text x="170" y="75" fontSize="16" style={{ animation: 'float 2s ease-in-out infinite' }}>💕</text>
            <text x="190" y="55" fontSize="12" style={{ animation: 'float 2.5s ease-in-out infinite 0.5s' }}>✨</text>
            <text x="155" y="55" fontSize="14" style={{ animation: 'float 3s ease-in-out infinite 1s' }}>🌹</text>
            <text x="200" y="70" fontSize="10" style={{ animation: 'float 2s ease-in-out infinite 0.3s' }}>💫</text>

            {/* Ground flowers */}
            <text x="60" y="220" fontSize="18">🌹</text>
            <text x="90" y="230" fontSize="14">🌸</text>
            <text x="250" y="222" fontSize="18">🌹</text>
            <text x="280" y="230" fontSize="14">🌷</text>
          </svg>
        </div>

        {/* Quote card */}
        <div style={{
          maxWidth: 660, margin: '0 auto 40px',
          background: 'linear-gradient(135deg, rgba(255,107,157,0.08), rgba(168,85,247,0.06))',
          border: '1px solid rgba(255,107,157,0.2)',
          borderRadius: 24, padding: 40,
          position: 'relative', overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute', top: 0, left: 0,
            width: '100%', height: '3px',
            background: 'linear-gradient(90deg, #ff6b9d, #a855f7, #38bdf8)',
          }} />
          <div style={{ fontSize: 40, marginBottom: 20 }}>💍</div>
          <p style={{
            fontFamily: 'Nunito, sans-serif', fontSize: 17, lineHeight: 1.9,
            color: '#e2c8d8', marginBottom: 20, fontStyle: 'italic',
          }}>
            On 27th July 2025, Hassan took a deep breath and opened his heart to Fiza. He spoke about his feelings — genuine, raw, and beautiful. He told her about his dil ki baat, the words he had kept close for so long.
          </p>
          <p style={{
            fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
            color: '#9b7ba8',
          }}>
            That day, a date was set. A promise was made. And two hearts took a step closer to something extraordinary. Some moments change everything — this was one of them. 🌹✨
          </p>
        </div>

        {/* Milestone row */}
        <div style={{
          display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap',
        }}>
          {[
            { icon: '💌', label: 'Dil Ki Baat' },
            { icon: '🌹', label: 'True Feelings' },
            { icon: '📅', label: 'Date Set' },
            { icon: '💕', label: 'New Beginning' },
          ].map(m => (
            <div key={m.label} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '12px 20px',
              background: 'rgba(255,107,157,0.06)',
              border: '1px solid rgba(255,107,157,0.15)',
              borderRadius: 50,
              fontFamily: 'Nunito, sans-serif', fontSize: 14, color: '#e2c8d8',
            }}>
              <span>{m.icon}</span> {m.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}